export default class SwitchButtonConfig {
    width?: string = '50px';
    height?: string = '25px';
    sizeHandle?: string = '24px';
    gap?: string = '0px';
    borderWidth?: string = '1px';
    borderColor?: string = '#888';
    checkedBorderColor?: string = '#3a9dbd';
    background?: string = '#fff';
    backgroundHandle?: string = '#888';
    checkedBackground?: string = '#fff';
    checkedBackgroundHandle?: string = '#3a9dbd';
    shadow?: string = 'none'// shadow?: string = '0 0 0 .1rem #268fff80;'
  
    constructor(init?: Partial<SwitchButtonConfig>) {
      Object.assign(this, init);
    }
  }
  